import React, {useState} from 'react'
import './index.less'
import Icon from "../../../../components/Icon";
import CyLogoImage from '../../../../assets/images/cy/cy-logo.png'
import {Form, Input, Button, Checkbox, Row, Col} from 'antd';
//import { UserOutlined, LockOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import { URL_CHANGYAN_VCODE, URL_CY_ADMIN_2026, URL_FORGET_PWD } from '../../../../constants/CyHomepage'
import {getLogin} from "../../../../request/CyHomepage";
import {URL_REGISTER_PC} from "../../../../constants/CyHomepage";
import {diffEndJump} from "../../../../utils/tools";

const clsPrefix = 'cy-login-modal'

// 记住我：仅在本地预填用户名（登录态本身在 HttpOnly cookie 里，与此无关）
const LS_LOGIN_NAME = 'cy_login_name'

function getSavedLoginName (): string {
  try {
    return localStorage.getItem(LS_LOGIN_NAME) || ''
  } catch (e) {
    return ''
  }
}

// 登录成功跳转：优先 url 上的 ?source=...；仅放行本站路径和 *.kuaizhan.com,
// 防止开放跳转。默认进新版后台 /admin2026/。
function loginRedirectTarget (): string {
  const source = new URLSearchParams(window.location.search).get('source')
  if (source) {
    try {
      const u = new URL(source, window.location.origin)
      if ((u.protocol === 'http:' || u.protocol === 'https:') &&
          (u.origin === window.location.origin ||
            u.hostname === 'kuaizhan.com' ||
            u.hostname.endsWith('.kuaizhan.com'))) {
        return u.href
      }
    } catch (e) { /* 非法 source 忽略,走默认 */ }
  }
  return URL_CY_ADMIN_2026
}
const LoginModal: React.FC<{
  header?: string | React.ReactNode,
  visible: boolean,
  onClose: () => void,
  className?: string,
  headerStyle?: React.CSSProperties,
  style?: React.CSSProperties,
  wrapperStyle?: React.CSSProperties,
  contentStyle?: React.CSSProperties
}> = ({
  header,
  visible = true,
  onClose = () => null,
  className = '',
  headerStyle = {},
  style,
  children,
  wrapperStyle,
  contentStyle
}) => {

  // const [checked, setChecked] = React.useState({ normal: true, partialChecked: true });
  const [ vcodeSrc, setvcodeSrc ] = useState(URL_CHANGYAN_VCODE)
  function handleClose () {
    onClose()
  }

  function onFinish (values) {
    console.log('Received values of form: ', values);
    // @ts-ignore
    // 此地登录统计pc端登录成功数
    if (window && window.xqui && window.xqui.useStat) {
      // @ts-ignore
      window.xqui.useStat({
        category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_login`,
        page: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`,
        action: 'click',
        bizType: 5,
      })
    }

    // 新 Go 后端：{code:0} 即成功（客服/站长后端已统一），登录态在
    // HttpOnly cookie 里；成功后按 ?source= 或默认 /admin2026/ 跳转。
    getLogin(values).then((res: any) => {
      if (!res) {
        return
      }
      if (res.code === 0) {
        try {
          if (values.rememberMe) {
            localStorage.setItem(LS_LOGIN_NAME, values.name)
          } else {
            localStorage.removeItem(LS_LOGIN_NAME)
          }
        } catch (e) { /* localStorage 不可用时忽略 */ }
        handleClose()
        location.assign(loginRedirectTarget())
      } else {
        // 验证码错/密码错都换一张验证码（密码错时后端已作废旧验证码）
        changeVcode(null);
        alert(res.msg || '登录失败')
      }
    }).catch((err) => {
      changeVcode(null);
      alert((err && err.msg) || '登录失败，请稍后再试')
    })
  }

  const formItemLayout = {
    labelCol: { span: 4, offset: 0.5 },
    wrapperCol: { offset: 0.5 },
  };

  // 目前不支持移动端的注册
  function handleRegister () {
    // @ts-ignore
    if (window && window.xqui && window.xqui.useStat) {
      // @ts-ignore
      window.xqui.useStat({
        category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_register`,
        page: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`,
        action: 'click',
        bizType:5,
      })
    }

    diffEndJump({
      href: URL_REGISTER_PC,
      isOpenNewWindow: false
    })
  }

  // function handleChecked(e) {
  //   console.log(e);
  //   setChecked({
  //     ...checked,
  //     [e.name]: e.checked,
  //   });
  // }

  function changeVcode(e) {
    console.log(e)
    new Date().getMilliseconds()
    let url = URL_CHANGYAN_VCODE + "?_" + new Date().getMilliseconds()
    setvcodeSrc(url)
  }


  return (
    <div className={`${clsPrefix} ${className} ${visible ? '' : `${clsPrefix}__invisible`}`} style={style}>
      <div className={`${clsPrefix}__mask`} onClick={handleClose} />
      <div className={`${clsPrefix}__wrapper`} style={wrapperStyle}>
        <div className={`${clsPrefix}__header`} style={headerStyle}>
          <img className={`${clsPrefix}__header__img`} src={CyLogoImage}></img>
          <div className={`${clsPrefix}__header__close-symbol`} onClick={handleClose}>
            <Icon name='raw-error' style={{ fontSize: '20px' }} />
          </div>
        </div>

        <div className={`${clsPrefix}__content`} style={contentStyle}>
          <Form
              {...formItemLayout}
              name="normal_login"
              className="login-form"
              initialValues={{ name: getSavedLoginName() }}
              onFinish={onFinish}
          >
            <Form.Item
                name="name"
                rules={[{ required: true, message: '请输入用户名!' }]}
            >
              <Input
                  placeholder="手机号/电子邮件" />
            </Form.Item>
            <Form.Item
              //  label='密  码：'
                name="password"
                rules={[{ required: true, message: '请输入密码!' }]}
            >
              <Input
                  type="password"
                  placeholder="密码"
              />
            </Form.Item>
            <Form.Item
                name="vcode"
                rules={[{ required: true, message: '请输入验证码!' }]}
            >
              <Row gutter={8} className="vcode">
                <Col span={12}>
                  <Form.Item
                      name="vcode"
                      noStyle
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <img id="vcode-img" onClick={changeVcode} src={ vcodeSrc }/>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item>
              <Form.Item name="rememberMe" valuePropName="checked" noStyle initialValue={true}>
                <Checkbox><span className="rememberMe">记住我</span></Checkbox>
              </Form.Item>

              <a className="login-form-forgot" href={URL_FORGET_PWD}>
                忘记密码？
              </a>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button">
                立即登录
              </Button>
            </Form.Item>
            <Form.Item>
            <Button type="default" htmlType="button" className="register-form-button" onClick={handleRegister}>
              马上注册
            </Button>
            </Form.Item>
            {/*<a onClick={handleRegister}>立即注册！</a>*/}
          </Form>
        </div>
      </div>
    </div>
  )
}


export  { LoginModal }
